import React, { useState, useEffect } from "react";
import { Button, IconButton, List } from "@mui/material";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import config from "../../api/config";
import NestedList from "../NestedList";

const EditingGroup = ({ group, _callback, modal, setModal }) => {
  const [cats, setCats] = useState(null);
  const [catId, setCatId] = useState(null);
  const [catName, setCatName] = useState(null);
  const [catBool] = useState(true);
  // get data
  useEffect(() => {
    if (group) {
      setCatId(group.resCategory?.id);
      config.get(`/api/category/v1`).then((data) => {
        setCats(data.data.objectKoinot);
        setCatName(
          data.data.objectKoinot.filter(
            (v) => v.id === group.resCategory?.id
          )[0]
        );
      });
    }
  }, [group]);

  // change

  // nested list item click event
  const clickHandler = (id) => {

    // setCatName(cats.filter((v) => v.id === id)[0]?.nameRu);
    setCatName(
      cats.filter((v) => {
        if (v.id === id) {
          return true;
        } else if (v.children.length > 0) {
          return v.children.some((v) => {
            if (v.id === id) {
              return true;
            } else if (v.children.length > 0) {
              return v.children.some((v) => v.id === id);
            } else {
              return false;
            }
          });
        } else {
          return false;
        }
      })[0]?.nameRu
    );
    setCatId(id);
  };

  const submitHandler = () => {
    _callback(true, {
      categoryId: catId,
      groupId: group.id,
      language: "EN",
    });
  };
  return (
    <div>
      {group ? (
        <Dialog
          open={modal}
          fullWidth
          maxWidth="md"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            className="d-flex justify-content-between align-items-center px-5"
          >
            <p>{group.name}</p>
            <IconButton onClick={() => setModal(false)}>
              <IoIosCloseCircleOutline />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <div className="w-100 p-3">
              <div className="d-flex justify-content-between align-items-center">
                <div className="">
                  <p className="fw-bold">
                    {group.resCategory
                      ? cats?.length > 0
                        ? catName
                        : null
                      : "Без Категории"}
                  </p>
                </div>
                <div className="">
                  {/* <Button onClick={changeCat} variant="contained">
                    Изменять
                  </Button> */}
                </div>
              </div>
              <div className={catBool ? "d-block" : "d-none"}>
                <List
                  sx={{ width: "100%" }}
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                >
                  {cats?.map((v, i) => (
                    <NestedList
                      key={i}
                      active={v.id === catId}
                      catId={catId}
                      item={v}
                      clickHandler={clickHandler}
                    />
                  ))}
                </List>
              </div>
            </div>
          </DialogContent>
          <DialogActions className="px-5 pb-3">
            <Button onClick={submitHandler} variant="contained" color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </div>
  );
};

export default EditingGroup;
